import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

const ERROR_MESSAGES: Record<string, string> = {
  no_token: 'Authentication failed. No token was received.',
  auth_failed: 'Authentication failed. Please try again.',
  http_error: 'Could not reach the authentication server. Please try again.',
};

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);

  protected readonly year = new Date().getFullYear();
  protected error = signal<string | null>(null);
  protected loading = signal(false);

  ngOnInit(): void {
    const errorCode = this.route.snapshot.queryParamMap.get('error');
    if (errorCode) {
      this.error.set(ERROR_MESSAGES[errorCode] ?? 'An unexpected error occurred.');
    }
  }

  login(): void {
    this.loading.set(true);
    this.error.set(null);
    this.authService.login({
      onError: () => {
        this.error.set(ERROR_MESSAGES['http_error']);
        this.loading.set(false);
      },
    });
  }
}
